import ReactGA from 'react-ga4'

export type AnalyticsSurface =
  | 'quote_new'
  | 'quote_old'
  | 'reallocate'
  | 'amend'

const env = (process.env.REACT_APP_B2C_ENVIRONMENTDETAILS || '').toLowerCase()
export const isAnalyticsDebug = env === 'dev' || env === 'staging'

export type AnalyticsUserProps = {
  user_role?: string
  client_id?: string
  client_name?: string
  brand?: string
}

let currentUserProps: AnalyticsUserProps = {}

export const setAnalyticsUser = (props: AnalyticsUserProps) => {
  currentUserProps = Object.fromEntries(
    Object.entries({ ...currentUserProps, ...props }).filter(
      ([, v]) => v !== undefined && v !== null && v !== '',
    ),
  ) as AnalyticsUserProps
  try {
    ReactGA.gtag('set', 'user_properties', currentUserProps)
  } catch {
    /* ignore */
  }
}

export const resetAnalyticsUser = () => {
  currentUserProps = {}
  try {
    ReactGA.gtag('set', 'user_properties', {})
  } catch {
    /* ignore */
  }
}

export const trackEvent = (name: string, params: Record<string, any> = {}) => {
  const cleaned = Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== null && !(typeof v === 'number' && isNaN(v)),
    ),
  )
  try {
    ReactGA.gtag('event', name, {
      ...currentUserProps,
      ...cleaned,
      ...(isAnalyticsDebug ? { debug_mode: true } : {}),
    })
  } catch {
    /* ignore */
  }
}
